// src/components/Hero.js

import React, { useEffect, useRef } from "react";
import "./Hero.css";

export default function Hero1() {
  const vantaRef = useRef(null);
  const effectRef = useRef(null);

  useEffect(() => {
    const threeScript = document.createElement("script");
    threeScript.src =
      "https://cdn.jsdelivr.net/npm/three@0.124.0/build/three.min.js";
    threeScript.async = true;
    threeScript.onload = () => {
      const vantaScript = document.createElement("script");
      vantaScript.src =
        "https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.cells.min.js";
      vantaScript.async = true;
      vantaScript.onload = () => {
        if (!effectRef.current && window.VANTA && window.VANTA.CELLS) {
          effectRef.current = window.VANTA.CELLS({
            el: vantaRef.current,
            THREE: window.THREE,
            color1: 0xff00ff, // magenta

            color2: 0xe3aee8, // cyan accent
            size: 1.5,
            backgroundColor: 0x000000,
            speed: 1.0, // pulsating motion
            scale: 1.0,
            scaleMobile: 0.8,
          });
        }
      };
      document.body.appendChild(vantaScript);
    };
    document.body.appendChild(threeScript);

    return () => effectRef.current?.destroy();
  }, []);

  return (
    <section id="home" ref={vantaRef}>
      <div className="hero-content">
        <h1>Hi, I’m Ankush</h1>
        <h2>Full Stack Developer</h2>
        <p>I craft modern web apps using React, Node.js, and MongoDB.</p>
        <a href="#contact" className="hero-btn">
          Let’s Talk
        </a>
      </div>
    </section>
  );
}
